import { DateTimeField, FormType, SelectField } from "@hex-insights/forms";
import { UserViewRecordFormValues } from "../../FormUtilities";
import { BaseFieldProps } from "../shared";
import { UserSelectField } from "../User";

/**
 * Generic props for fields of the UserViewRecord model.
 */
type FieldProps<K extends keyof UserViewRecordFormValues.Base = keyof UserViewRecordFormValues.Base> = BaseFieldProps<
	Pick<UserViewRecordFormValues.Base, K>
>;

/**
 * Generic props for fields of the UserViewRecord model that only appear in the detail form.
 */
type DetailFieldProps<K extends keyof UserViewRecordFormValues.Detail = keyof UserViewRecordFormValues.Detail> =
	BaseFieldProps<Pick<UserViewRecordFormValues.Detail, K>>;

/**
 * Field component for the `targetID` field of the UserViewRecord model.
 */
export function TargetID({ formState, ...props }: FieldProps<"targetID">) {
	// Customized
	return <SelectField formState={formState} name="targetID" options={[]} {...props} />;
}

/**
 * Field component for the `firstViewedAt` field of the UserViewRecord model.
 */
export function FirstViewedAt({ formState, ...props }: DetailFieldProps<"firstViewedAt">) {
	return (
		<DateTimeField
			formState={formState}
			name="firstViewedAt"
			optional={FormType.isCreate(formState.formType)}
			precision="minute"
			{...props}
		/>
	);
}

/**
 * Field component for the `lastViewedAt` field of the UserViewRecord model.
 */
export function LastViewedAt({ formState, ...props }: DetailFieldProps<"lastViewedAt">) {
	return (
		<DateTimeField
			formState={formState}
			name="lastViewedAt"
			optional={FormType.isCreate(formState.formType)}
			precision="minute"
			{...props}
		/>
	);
}

export namespace User {
	export type SelectProps = DetailFieldProps<"userID"> &
		Omit<UserSelectField.SelectProps<UserViewRecordFormValues.Detail>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `user` edge of the UserViewRecord model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <UserSelectField.Select formState={formState} name="userID" {...props} />;
	}
}
